import React from 'react';

interface PortsIconProps {
    isActive?: boolean;
}

const PortsIcon: React.FC<PortsIconProps> = ({ isActive = false }) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
                x="2.5"
                y="5.5"
                width="11"
                height="9"
                rx="1.5"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
            />
            <path d="M6 5.5V1.5" stroke="currentColor" strokeLinecap="round"/>
            <path d="M10 5.5V1.5" stroke="currentColor" strokeLinecap="round"/>
            <path d="M6 9.5H10" stroke="currentColor" strokeLinecap="round"/>
        </svg>
    );
};

export default PortsIcon;
